<template lang="pug">
  .hidden-menu(v-if="items")
    div.hidden-menu__toggle(v-on:click="showMenu" :class="{'hidden-menu__toggle--close': menuShow}")
      span.hidden-menu__toggle-line
      span.hidden-menu__toggle-line
      span.hidden-menu__toggle-line
    nav.hidden-menu__nav
      router-link.hidden-menu__nav-item(v-for='item in items', :to="item.link", :key="item.id")
        .hidden-menu__nav-item-circle
        p.hidden-menu__nav-item-text {{item.title}}
</template>

<script>

import EventBus from '@/eventBus';

export default {
  name: 'HiddenMenu',
  data() {
    return {
      menuShow: false,
    }
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: null
    }
  },
  created() {
    EventBus.$on('menuHide', () => {
      this.hideMenu();
    })
  },
  methods: {
    showMenu() {
      if (!this.menuShow) {
        $('.header__top-right').css('opacity', '0');
        $('.header__avax').css('opacity', '0');
        $('.page__items').css('opacity', '0');
        $('.hidden-menu__nav').css('display', 'flex')
        setTimeout(() => {
          this.menuShow = true;
          $('.hidden-menu').removeClass('hidden-menu--close');
          $('.hidden-menu').addClass('hidden-menu--open');
          $('.hidden-menu__nav').css({'opacity': '1', 'z-index': '0'});
          $('.hidden-menu__nav-item').css({'transform': 'translateX(0)'});
          $('.page__items').css('display', 'none');
        }, 200);
      } else {
        this.hideMenu();
      }
    },
    hideMenu() {
      this.menuShow = false;
      $('.hidden-menu__nav').css('display', 'none')
      $('.hidden-menu__nav-item').css({'transform': 'translateX(-70vw)'});
      setTimeout(() => {
        $('.page__items').css('display', 'block');
        $('.hidden-menu__nav').css({'opacity': '0', 'z-index': '-2'});
        $('.hidden-menu').removeClass('hidden-menu--open');
        $('.hidden-menu').addClass('hidden-menu--close');
        $('.header__top-right').css('opacity', '1');
        $('.header__avax').css('opacity', '1');
        $('.page__items').css('opacity', '1');
      }, 300);
    },
  }
}
</script>
